import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("详情")

import {defineComponent, reactive, ref} from "vue"
import ApprovalTable from "@/components/ApprovalTable.vue"
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

let {statusFilter,filterType}=PaymentModuleUtils
let {MI_height} = new tbMix(() => Promise.resolve())

const {
    'POST/approved/records': approvalHistoryApi,
    //审批记录详情列表
    'POST/approved/query_details':approvedQuerySetailsApi,
} = Api
const approvalHistoryData=ref([])
const historyTableLoading=ref(false)
const tableLoading=ref(false)
const approvedRecordId:any=ref(null)
const historyPageSetting=reactive({
    page:1,
    size:30,
    totalNum:0
})
const pageSetting=reactive({
    page:1,
    size:30,
    totalNum:0
})
const historyDetailData=ref([])
const detailDialogVisible=ref(false)
const queryForm=ref({
    no:"",
    approvedRecordId:"",
    payApproveStatus:"APPROVE_WAIT",
    approvedName:"",
    reimburseType:""
})
const transformationTime=(time:string)=>{
    return dayjs(time).format("YYYY-MM-DD HH:mm:ss")
}
const openApprovalHitory=()=>{
    let {page,size}=historyPageSetting
    historyTableLoading.value=true
    approvalHistoryApi({page,size,query:queryForm.value}).then((res:any)=>{
        approvalHistoryData.value=res.data
        historyPageSetting.totalNum=res.rowCount
        historyTableLoading.value=false
    }).catch(()=>{
        historyTableLoading.value=false
    })
}
const queryMethod=(isQuery: boolean)=>{
    historyPageSetting.page = 1
    if(!isQuery){
        queryForm.value = {
            no:"",
            approvedRecordId:"",
            payApproveStatus:"APPROVE_WAIT",
            approvedName:"",
            reimburseType:""
        }
        return
    }
    openApprovalHitory()
}
// 执行一次获取历史记录数据
openApprovalHitory()        
const hisPageChange=(page: number)=>{
    historyPageSetting.page = page
    openApprovalHitory()
}
const hisSizeChange=(size: number)=>{
    historyPageSetting.size = size
    openApprovalHitory()
}
const getDetailTableData=(id?:number)=>{
    tableLoading.value=true
    approvedRecordId.value=id||approvedRecordId.value
    let {page,size}=pageSetting
    let formdata=new FormData()
    formdata.append('page',page.toString())
    formdata.append('size',size.toString())
    formdata.append('approvedRecordId',approvedRecordId.value)
    approvedQuerySetailsApi(formdata).then((res:any)=>{
        historyDetailData.value=res.data
        pageSetting.totalNum=res.rowCount
        tableLoading.value=false
    })
}
const openApprovedDetail=(id:number)=>{
    detailDialogVisible.value=true
    getDetailTableData(id)
}

const pageChange=(page:number)=>{
    pageSetting.page=page
    getDetailTableData()
}

expose({
    openApprovalHitory
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, { accordion: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          name: "1",
          title: "HR审批记录-搜索"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              inline: true,
              model: queryForm.value,
              class: "demo-form-inline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "编号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.value.no,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.no) = $event)),
                      placeholder: "请输入编号",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "打包编号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.value.approvedRecordId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.approvedRecordId) = $event)),
                      placeholder: "请输入打包编号",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "Hr审批人" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.value.approvedName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.value.approvedName) = $event)),
                      placeholder: "请输入Hr审批人",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (queryMethod(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (queryMethod(false)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: approvalHistoryData.value,
      border: "",
      class: "mt-10",
      style: {"width":"60%"},
      "max-height": _unref(MI_height) - 30 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "打包编号",
          formatter: (row) => 'DB' + row.id
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "reimburseType",
          label: "费用类型"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_unref(filterType)(row.reimburseType)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "approvedName",
          label: "Hr审批人"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approvedTime",
          label: "审批时间",
          width: "170"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(transformationTime(row.approvedTime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "subRecordsNum",
          label: "子单个数",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approvedNum",
          label: "审批个数",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payApproveStatus",
          label: "Hr审批状态"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_unref(statusFilter)(row.payApproveStatus)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "ops",
          label: "操作"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (openApprovedDetail(row.id))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, historyTableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      "page-size": _unref(historyPageSetting).size,
      "page-sizes": [10, 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total",
      total: _unref(historyPageSetting).totalNum,
      class: "mt-10",
      style: {"float":"none"},
      onCurrentChange: hisPageChange,
      onSizeChange: hisSizeChange,
      currentPage: _unref(historyPageSetting).page,
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_unref(historyPageSetting).page) = $event))
    }, null, 8, ["page-size", "total", "currentPage"]),
    _createVNode(_component_el_dialog, {
      modelValue: detailDialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((detailDialogVisible).value = $event)),
      title: "详情",
      width: "1500px",
      draggable: ""
    }, {
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _createVNode(ApprovalTable, {
          canEdit: false,
          tableData: historyDetailData.value,
          tableLoading: tableLoading.value,
          onPageChange: pageChange,
          totalNumber: _unref(pageSetting).totalNum
        }, null, 8, ["tableData", "tableLoading", "totalNumber"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})